<template>
    <div class="view">

        <Head @ck="menuOpen=true">{{ $t("menu.myClass")}}</Head>
        <router-view></router-view>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
import ClassItem from '@/components/ClassItem'
export default {
    name: 'MyClass',
    mixins: [mainDelegate]
}
</script>

<style lang="less" scoped>
@import 'val.less';
@import 'view.less';
</style>



// WEBPACK FOOTER //
// src/page/MyClass.vue